module.exports = __webpack_public_path__ + "static/media/goodreads-g.6846ee54.svg";